import Bus from './bus'

const tBus: any = Bus;
export default tBus;